import getXHR, { XhrResponse } from 'Partials/xhr';
import { PricingFrequency } from '../modalUpgrade';

export class Coupon {
    public static verify(options: CouponVerifyOptions): Promise<CouponVerifyResponse> {
        let url = `${BASE_URL}ajax/pricing/discount?frequency=${options.frequency}`;
        if (options.coupon) {
            url += `&discountCode=${options.coupon}`;
        }
        return getXHR(url, {
            method: 'GET',
            withCredentials: true,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        });
    }
}

export interface CouponVerifyOptions {
    coupon: string;
    frequency: PricingFrequency;
}

export interface CouponVerifyResponse extends XhrResponse {
    success: boolean;
    data: {
        price: string;
        priceWithoutTaxes: string;
        taxesAmount: string;
    };
}
